import { render } from "./ChatsList.vue?vue&type=template&id=2df76550"
import script from "./ChatsList.vue?vue&type=script&lang=js"
export * from "./ChatsList.vue?vue&type=script&lang=js"

import "./ChatsList.vue?vue&type=style&index=0&id=2df76550&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__